<div mdbModal #verRutasCamionModal="mdb-modal" class="modal fade" id="dvModalMostrarRutas" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }"
  style="z-index: 1060;">
  <div class="modal-dialog modal-lg" role="document" style="z-index: 1060;">
    <div class="modal-content">
      <div class="modal-header" style="padding-bottom: 4px; padding-top: 0px;">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Mostrar Rutas
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="verRutasCamionModal.hide(); clearModal()"
          style="margin-top: 0px; height: 41px; padding-top: 5‒; padding-top: 5px;">
          <span aria-hidden="true">×</span>
        </button>
      </div>

      <div class="modal-body" style="overflow-y:auto;height: 480px;">
        <div class="card-body justify-content-between">
          <div class="row filtros-body">
            <div class="col" style="max-width:100%;">
              <agm-map id="mapRutas" (mapReady)="onMapReadyShowRutas($event)" [styles]="customStyle">
                <!-- Marcadores personalizados con InfoWindows -->
                <agm-marker *ngFor="let punto of puntosRuta; let i = index" [latitude]="punto.lat"
                  [longitude]="punto.lng" [iconUrl]="punto.iconUrl" [zIndex]="1000" (markerClick)="abrirInfoWindow(i)">
                  <agm-info-window #infoWindow [isOpen]="punto.infoWindowAbierto">
                    <div class="info-window" style="min-width: 250px;">
                      <h6 style="color: #007bff; margin-bottom: 8px;"><strong>N° Doc:</strong> {{ punto.numerosDocumento
                        }}</h6>
                      <p style="margin: 4px 0; font-size: 14px;"><strong>Dirección:</strong> {{ punto.direccion }}</p>
                      <p style="margin: 4px 0; font-size: 14px;"><strong>Comuna:</strong> {{ punto.comuna }}</p>
                      <p style="margin: 2px 0; font-size: 12px; color: #ff6b35;">
                        <strong>⚠️ Punto duplicado</strong> - Misma dirección
                      </p>
                      <!-- Verificar si hay otros documentos en la misma dirección -->
                      <div *ngIf="obtenerDocumentosEnMismaDireccion(punto.direccion).length > 1"
                        style="margin: 8px 0; padding: 8px; background-color: #f8f9fa; border-radius: 4px;">

                        <p style="margin: 2px 0; font-size: 12px; color: #6c757d;">
                          <strong>Documentos en esta ubicación:</strong>
                        </p>
                        <div *ngFor="let doc of obtenerDocumentosEnMismaDireccion(punto.direccion); let i = index"
                          style="margin: 2px 0; font-size: 12px;">
                          <span style="color: #007bff;">•</span> {{ doc.numerosDocumento }}
                          <span *ngIf="doc.prioridad > 0" style="color: #dc3545; font-weight: bold;"> (P:{{
                            doc.prioridad }})</span>
                        </div>
                      </div>

                      <p style="margin: 4px 0; font-size: 14px;"
                        [style.color]="punto.prioridad > 0 ? '#dc3545' : '#6c757d'">
                        <strong>Prioridad:</strong> {{ punto.prioridad > 0 ? punto.prioridad : 'Sin prioridad' }}
                      </p>
                    </div>
                  </agm-info-window>
                </agm-marker>
              </agm-map>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer"
        style="padding-top: 0px; padding-bottom: 0px; padding-left: 0px; padding-right: 0px; min-height: 71px; flex-direction: column;">

        <!-- Sección de puntos duplicados -->
        <div *ngIf="puntosDuplicados.length > 0" class="w-100 mb-2"
          style="background-color: #f8f9fa; border-left: 4px solid #007bff; border-radius: 6px; padding: 10px 15px; margin: 8px 12px;">
          <div style="font-size: 13px; color: #007bff; margin-bottom: 6px; font-weight: bold;">
            📍 Puntos con múltiples documentos:
          </div>
          <div *ngFor="let duplicado of puntosDuplicados; let i = index"
            style="font-size: 12px; color: #495057; margin: 3px 0; display: flex; align-items: center;">
            <span style="font-weight: bold; color: #dc3545; margin-right: 5px;">{{ duplicado.letra }}:</span>
            <span style="flex: 1;">{{ duplicado.direccion }}</span>
            <span
              style="color: #dc3545; font-weight: bold; background-color: #f8d7da; padding: 2px 6px; border-radius: 3px; font-size: 11px;">
              {{ duplicado.cantidad }} doc{{ duplicado.cantidad > 1 ? 's' : '' }}
            </span>
          </div>
        </div>

        <!-- Botón Cerrar centrado abajo -->
        <div class="w-100 text-center mt-2">
          <button type="button" class="btn btn-default waves-light" data-dismiss="modal"
            (click)="verRutasCamionModal.hide(); clearModal()" mdbWavesEffect>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
